const DOT = '.'.charCodeAt(0);
const INET_ADDRESS_V4_SIZE = 4;
const INET_ADDRESS_V6_SIZE = 16;
const BYTE_SIZE = 2; // 8 bits in hex
const COLON = ':'.charCodeAt(0);

export function textToNumericFormatV4(address: string): Uint8Array {
    const result = new Uint8Array(4);
    const len = address.length;
    if (len == 0 || len > 15) {
        return;
    }

    let currentValue = 0;
    let currentByte = 0;
    let newByte = true;
    for (let i = 0; i < len; i++) {
        const ch = address.charCodeAt(i);
        if (ch === DOT) {
            if (newByte || currentValue < 0 || currentValue > 0xff || currentByte > 3) {
                return;
            }
            result[currentByte++] = currentValue & 0xff;
            currentValue = 0;
            newByte = true;
        } else {
            const digit = ch - 48;
            if (digit < 0) {
                return;
            }
            currentValue *= 10;
            currentValue += digit;
            newByte = false;
        }
    }
    if (newByte || currentValue < 0 || currentValue >= (1 << ((4 - currentByte) * 8))) {
        return;
    }

    switch (currentByte) {
        case 0:
            result[0] = (currentValue >> 24) & 0xff;
        //fall through
        case 1:
            result[1] = (currentValue >> 16) & 0xff;
        //fall through
        case 2:
            result[2] = (currentValue >> 8) & 0xff;
        //fall through
        case 3:
            result[3] = (currentValue >> 0) & 0xff;
    }
    return result;
}

export function textToNumericFormatV6(address: string): Uint8Array {
    if (address.length < 2) {
        return;
    }

    // let colonp: number;
    // let char: number;
    // let saw_xdigit: boolean;
    // let val: number;
    // const dst = new Uint8Array(INET_ADDRESS_V6_SIZE);
    //
    // const srcb_length = address.length;
    // const pc = src.indexOf('%');
    // if (pc === srcb_length -1) {
    //     return;
    // }
    //
    // colonp = -1;
    //
    // let i = 0, j = 0;
    //     /* Leading :: requires some special handling. */
    //     if (address.charAt(i) === ':')
    //         if (address.charAt(++i) !== ':')
    //             return;
    //     curtok = i;
    //     saw_xdigit = false;
    //     val = 0;
    //     while (i < srcb_length) {
    //         const ch = address.charCodeAt(i++);
    //         const chval = ch - 48;
    //         if (chval !== -1) {
    //             val <<= 4;
    //             val |= chval;
    //             if (val > 0xffff)
    //                 return;
    //             saw_xdigit = true;
    //             continue;
    //         }
    //         if (ch == ':') {
    //             curtok = i;
    //             if (!saw_xdigit) {
    //                 if (colonp != -1)
    //                     return null;
    //                 colonp = j;
    //                 continue;
    //             } else if (i == srcb_length) {
    //                 return null;
    //             }
    //             if (j + INT16SZ > INADDR16SZ)
    //                 return null;
    //             dst[j++] = (byte) ((val >> 8) & 0xff);
    //             dst[j++] = (byte) (val & 0xff);
    //             saw_xdigit = false;
    //             val = 0;
    //             continue;
    //         }
    //         if (ch == '.' && ((j + BYTE_SIZE) <= INET_ADDRESS_V6_SIZE)) {
    //             const ia4 = address.substring(curtok, srcb_length);
    //             /* check this IPv4 address has 3 dots, ie. A.B.C.D */
    //             let dot_count = 0, index=0;
    //             while ((index = ia4.indexOf ('.', index)) != -1) {
    //                 dot_count ++;
    //                 index ++;
    //             }
    //             if (dot_count != 3) {
    //                 return null;
    //             }
    //             const v4addr = textToNumericFormatV4(ia4);
    //             if (v4addr == null) {
    //                 return null;
    //             }
    //             for (let k = 0; k < INET_ADDRESS_V4_SIZE; k++) {
    //                 dst[j++] = v4addr[k];
    //             }
    //             saw_xdigit = false;
    //             break;  /* '\0' was seen by inet_pton4(). */
    //         }
    //         return null;
    //     }
    //     if (saw_xdigit) {
    //         if (j + INT16SZ > INADDR16SZ)
    //             return null;
    //         dst[j++] = (byte) ((val >> 8) & 0xff);
    //         dst[j++] = (byte) (val & 0xff);
    //     }
    //
    //     if (colonp != -1) {
    //         const n = j - colonp;
    //
    //         if (j == INADDR16SZ)
    //             return null;
    //         for (i = 1; i <= n; i++) {
    //             dst[INADDR16SZ - i] = dst[colonp + n - i];
    //             dst[colonp + n - i] = 0;
    //         }
    //         j = INADDR16SZ;
    //     }
    //     if (j != INADDR16SZ)
    //         return null;
    //     const newdst = convertFromIPv4MappedAddress(dst);
    //     if (newdst != null) {
    //         return newdst;
    //     } else {
    //         return dst;
    //     }
}
